import React from 'react'
import TextField from './../../shared/components/fields/textField/TextField';
import { I18n } from 'react-redux-i18n';
import SelectField from "../../shared/components/fields/selectField/SelectField";
import ExpandSwitchesContainer from "../../shared/components/others/expandSwitches/ExpandSwitchesContainer";
import Alert from "../../shared/components/alerts/Alert";
import FormButtons from "../../shared/components/others/formButtons/FormButtons";
import { appModules } from './UserHasPermission';

const RolesForm = ({
    handlePermissionChanged,
    handlePermissionGroupChanged,
    permissionGroups,
    roleFormData: {
        name,
        entity,
    },
    alert,
    editMode,
    createMode,
    viewMode,
    entityList,
    handleFieldChange,
    handleOnFieldBlur,
    handleSubmitClick,
    handleBackClick,
    handleEditClick,
    handleDeleteClick,
}) => {
    return <div className="form-container">
        <div className="form">
            <Alert
                {...alert}
            />
            <div className="header">
                {buildHeader(createMode, editMode, viewMode)}
            </div>
            <div className="fields">
                <div id="role-fields-1" className="field-row">
                    <div className="row">
                        <TextField
                            value={name.value}
                            label={I18n.t("roles.form.name.label")}
                            handleFieldChange={value => handleFieldChange("name", value)}
                            handleFieldBlur={() => handleOnFieldBlur("name")}
                            themeName="form"
                            error={name.error}
                            disabled={viewMode}
                            width={4}
                        />
                        <SelectField
                            handleFieldChange={value => handleFieldChange("entity", value)}
                            value={entity.value}
                            label={I18n.t("roles.form.entity.label")}
                            options={entityList}
                            error={entity.error}
                            disabled={viewMode || editMode}
                            width={4}
                        />
                    </div>
                </div>
                <div id="user-fields-2">
                    <div>
                        {I18n.t("roles.form.permissions")}
                    </div>
                    <div className="field-row">
                        <ExpandSwitchesContainer
                            handlePermissionChanged={handlePermissionChanged}
                            handlePermissionGroupChanged={handlePermissionGroupChanged}
                            permissionGroups={permissionGroups}
                            disabled={viewMode}
                        />
                    </div>
                </div>
            </div>
            {(createMode || editMode) &&
        <div className="buttons">
            <button
                className=" mt-3 btn btn-primary"
                onClick={handleSubmitClick}
            >
                {I18n.t("forms.save")}
            </button>
        </div>
        }
        </div>
        <div className="form-options">
            <FormButtons
                editMode={editMode}
                viewMode={viewMode}
                handleBackClick={handleBackClick}
                handleEditClick={handleEditClick}
                handleDeleteClick={handleDeleteClick}
                appModule={appModules.ROLE}
            />
        </div>
    </div>
};

function buildHeader(createMode, editMode) {
    return createMode ?
        I18n.t("roles.form.headers.create") :
        editMode ?
            I18n.t("roles.form.headers.edit") :
            I18n.t("roles.form.headers.view");
}

export default RolesForm;